import { createSlice } from "@reduxjs/toolkit";
import { CreateNewPasswordState } from "./index.types";

export const initialState: CreateNewPasswordState = {
  creatNewPasswordsIsLoading: false,
  creatNewPasswordsSuccess: false,
};

const name = "createNewPassword";

export const createNewSliceSlice = createSlice({
  name,
  initialState: initialState,
  reducers: {
    createNewPassword: (state) => {
      state.creatNewPasswordsIsLoading = true;
    },
    clearCreateNewPasswordData: (state) => {
      state.creatNewPasswordsIsLoading = false;
      state.creatNewPasswordsSuccess = false;
    },
  },
});

export const { createNewPassword, clearCreateNewPasswordData } = createNewSliceSlice.actions;

export default createNewSliceSlice.reducer;

export const createNewPasswordAPI = (body: any, hiddenToken: string, isReset: string) => ({
  payload: {
    apiName: name,
    method: "post",
    data: body,
    url: isReset == "true" ? `/api/reset-password/${hiddenToken}/` : `/api/change-password/${hiddenToken}/`,
  },
  type: "createNewPassword",
});

export const getCSRF = () => ({
  payload: {
    apiName: name,
    method: "get",
    url: `/api/csrf-token/`,
  },
  type: "getCSRF",
});
